export default __webpack_public_path__ + "static/media/closeIcon.4eb2df9d.svg";